import _ from 'lodash'
import $ from 'jquery'
import GenericOverviewInfoDisplayHeader from 'scoreboard/components/overview-info/generic-overview-info-display-header'
import config from 'scoreboard/components/config'
import globals from 'scoreboard/components/globals'
import ScorecardOverviewInfo from './overview/scorecards-overview-info'
import appDisplay from 'scoreboard/components/app-display'
import spectator from 'scoreboard/components/spectator'
import ScorecardNode from './scorecard-node'
import Tooltip from 'scoreboard/components/tooltip'
import AlertSubscriptionList from 'scoreboard/alerts/alert-subscription-list'
import DomainAlertSubscriptionForm from 'scoreboard/alerts/domain-alert-subscription-form'

var ScorecardsDisplayHeader = GenericOverviewInfoDisplayHeader.extend({

	events: _.extend({}, GenericOverviewInfoDisplayHeader.prototype.events, {
		'click .open-alerts': 'alertsInfo'
	}),

	initialize: function(options) {
		options = _.assign({periods: true}, options)
		GenericOverviewInfoDisplayHeader.prototype.initialize.apply(this, arguments)
	},

	/**
	 * The presense of this function includes the overview button in the header
	 */
	overviewInfo: function() {
		var id = _.result(this, 'model.id') || this.options.domainId
		var sn = new ScorecardNode({ id: id })
		appDisplay.dialog(sn.fetch({
			data: {
				owners: true,
				updaters: true,
				tags: true,
				templateInfo: true,
				relatedItems: true,
				linkedItems: true,
				percentWeightingIgnoringPerformance: true,
				calendarPeriodId: globals.periodId,
				datasets: true
			}
		}), function() {
			return new ScorecardOverviewInfo({ model: sn })
		}.bind(this))
	},

	/**
	 * Styles the button alert based on the state of the scorecard node.
	 * (Visible or not, active or not)
	 */
	styleAlertButton: function() {
		const {type, subscriptions} = this.model.attributes
		if (this.alertButton) {
			this.alertButton
				.addClass('scorecard-alerts')
				.toggleClass('has-alerts', !_.isEmpty(subscriptions))
				.toggleClass('is-not-displayed', !type || 'docking' === type)
			// No counts for scorecard subscriptions (23513)
			this.alertButton.find('.alert-count')
				.toggleClass('is-not-displayed', true)
		}
	},

	/**
	 * The presence of this function includes the alerts button in the header
	 */
	alertsInfo: function(e) {
		// Invoked from the mobile toolbar dropdown
		if (_.isUndefined(e)) {
			const form = new DomainAlertSubscriptionForm({model: this.model})
			form.on('done', subscriptions => this.styleAlertButton())
			appDisplay.dialog(form)
		// Invoked from the non-mobile button toolbar
		} else {
			const target = $(e.currentTarget)
			const alertPopup = new AlertSubscriptionList({model: this.model})
			alertPopup.on('done', () => this.styleAlertButton())
			this.alertsTooltip = new Tooltip({
				attachTo: target,
				content: alertPopup,
				placement: 'below',
				arrow: 'right',
				extraClass: 'has-bootslide-menu'
			}).render()
		}
	},

	toggleRedDescendants: function(descendantLowestScore) {
		// don't display the red metrics indicator in bookmarks and briefings
		if (spectator.getCurrent()) {
			return
		}
		// don't show the indicator if one wasn't configured
		if (_.isNil(config.descendantLowestScoreThreshold)) {
			return
		}

		let red
		// issue #5412 if lowest score unknown, don't display exclamation point
		if (descendantLowestScore == null || _.isUndefined(descendantLowestScore)) {
			red = false
		} else {
			red = descendantLowestScore < config.descendantLowestScoreThreshold
		}
		this.$('.icon-red-descendants').toggleClass('is-not-displayed', !red)
	},

	remove: function() {
		GenericOverviewInfoDisplayHeader.prototype.remove.apply(this, arguments)
		_.invokeMap([this.alertsTooltip], 'remove')
	}

})

export default ScorecardsDisplayHeader

ScorecardsDisplayHeader.__filename__ = 'scorecards/scorecards-display-header.js'
